"use client";

import { Check, Target, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SpecializedRecruitmentSolutionBlockOne() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: block1Ref,
    isVisible: block1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: block2Ref,
    isVisible: block2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}